module.exports = __webpack_public_path__ + "static/media/counter-image.2ce667a5.svg";